@if (alertLoading === true) {
<div [ngClass]="{
  'body-alert': showOverlay
}">
      <div class="text-center" [ngClass]="{
        'div-alert': showOverlay
      }">
      <p class="subtitulo-alert">Carregando seu arquivo.</p>
      <p class="subtitulo-alert mt-2">{{statusUpload}} %</p>
      @if (statusFase == 0) {
        <p class="paragrafo mt-2"><strong class="c-primary">Status do processo:</strong> Lendo arquivo.</p>
      }
      @if (statusFase == 1) {
        <p class="paragrafo mt-2"><strong class="c-primary">Status do processo:</strong> Validação do arquivo.</p>
      }
      @if (statusFase == 2) {
        <p class="paragrafo mt-2"><strong class="c-primary">Status do processo:</strong> Validação de benefícios.</p>
      }
      @if (statusFase == 3) {
        <p class="paragrafo mt-2"><strong class="c-primary">Status do processo:</strong> Validação de endereços.</p>
      }
      @if (statusFase == 4) {
        <p class="paragrafo mt-2"><strong class="c-primary">Status do processo:</strong> Validação de usuários.</p>
      }
      @if (statusFase == 5) {
        <p class="paragrafo mt-2"><strong class="c-primary">Status do processo:</strong> Importação de dados.</p>
      }
      @if (statusFase == 6) {
        <p class="paragrafo mt-2"><strong class="c-primary">Status do processo:</strong> Validação geral.</p>
      }
      @if (statusFase == 7) {
        <p class="paragrafo mt-2"><strong class="c-primary">Status do processo:</strong> Resumindo problemas.</p>
      }
      @if (statusFase == 8) {
        <p class="paragrafo mt-2"><strong class="c-primary">Status do processo:</strong> Validação de empresas.</p>
      }
      @if (statusFase == 9) {
        <p class="paragrafo mt-2"><strong class="c-primary">Status do processo:</strong> Importação encerrada.</p>
      }
      <div class="progresso mt-2">
        <div class="barra" style.width="{{statusUpload}}%"></div>
      </div>
    </div>
  </div>
}
